import script from "./groupCustomTips.vue?vue&type=script&setup=true&lang=js"
export * from "./groupCustomTips.vue?vue&type=script&setup=true&lang=js"

import "./groupCustomTips.vue?vue&type=style&index=0&id=4686b910&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4686b910"]])

export default __exports__